export default {"src":"/_next/static/media/icon_gift.47a779d1.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};